import { render, staticRenderFns } from "./CostsLimitsSummary.vue?vue&type=template&id=fd90c760&scoped=true&"
import script from "./CostsLimitsSummary.vue?vue&type=script&lang=js&"
export * from "./CostsLimitsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd90c760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
